import { Box } from "@mui/material";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function FeedPage() {
  const worker = useDefinedWorker();

  const { userId: workerId, firstName: workerName } = worker;

  const iframeUrl = new URL("https://social-v0-production.up.railway.app/display");
  iframeUrl.searchParams.set("workerId", workerId);
  iframeUrl.searchParams.set("workerName", workerName ?? "");

  return (
    <Box height="100%" position="relative">
      <iframe
        allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
        src={iframeUrl.toString()}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        title="viewVideo"
      />
    </Box>
  );
}
